import { createAction, props } from '@ngrx/store';
import { RewardQty, Rewards } from './rewards.state';
import { Params } from '@angular/router';
import { Reward, RewardPreferenceCategory } from 'src/app/utility/model/reward';

// Rewards
export const getRewards = createAction('[Rewards] Get Rewards');

export const getRewardsSuccess = createAction(
  '[Rewards] Get Rewards Success',
  props<{ rewards: Rewards }>(),
);

export const getRewardsFailure = createAction(
  '[Rewards] Get Rewards Failure',
  props<{ error: any }>(),
);

export const updateRewardsParams = createAction(
  '[Rewards] Update Rewards Params',
  props<{
    params: Params;
  }>(),
);

// Get Reward Details
export const getRewardDetails = createAction(
  '[Reward API] Get Reward Details',
  props<{ id: number }>(),
);

export const getRewardDetailsSuccess = createAction(
  '[Reward API] Get Reward Success',
  props<{ reward: Reward }>(),
);

export const getRewardDetailsFailure = createAction(
  '[Reward API] Get Reward Failure',
  props<{ error: any }>(),
);
export const clearRewardDetails = createAction(
  '[Reward API] Clear Reward Details',
);

// Rewards Sub Category Preference
export const getRewardsCatAndSubCatPreference = createAction(
  '[Rewards] Get Rewards Cat And SubCat Preference',
);
export const getRewardsCatAndSubCatPreferenceSuccess = createAction(
  '[Rewards] Get Rewards Cat And SubCat Preference Success',
  props<{ rewardCategories: RewardPreferenceCategory[] }>(),
);
export const getRewardsCatAndSubCatPreferenceFailure = createAction(
  '[Rewards] Get Rewards Cat And SubCat Preference Failure',
  props<{ error: any }>(),
);
export const setRewardQty = createAction(
  '[RewardQty] Set Reward Quantity',
  props<{ rewardQty: RewardQty }>(),
);
export const setRewardSpinner = createAction(
  '[Reward] Set Reward Spinner',
  props<{ spinner: boolean }>(),
);
export const updateRewardsCatAndSubCatPreferenceParams = createAction(
  '[Rewards] Update Rewards Cat And Sub Cat Preference Params',
  props<{
    rewardCatAndSubCatParams: Params;
  }>(),
);
